import { useForm, Controller } from "react-hook-form";
import { FormContainer, TextInput } from "../../shared";
import { RESET_PASSWORD } from "./query";
import useGlobalMutation from "../../../hooks/useGlobalMutation";
import { RegexPattern } from "../../../utils";

const ResetPassword = ({ id }) => {
    const {
        register,
        control,
        handleSubmit,
        formState: { errors },
        reset,
        watch,
    } = useForm({
        mode: "onChange",
        defaultValues: {
            password: "",
        },
    });

    const password = watch("password", "");
    const { submitMutation, loading } = useGlobalMutation(RESET_PASSWORD);

    const submitAction = handleSubmit(async (data) => {
        const { password } = data;
        const variables = {
            userId: id,
            password,
            minLength: "8",
        };
        const successMgs = `Password successfully reset`;

        await submitMutation(variables, "basicLoginResetPassword", successMgs);
        reset();
    });

    return (
        <FormContainer
            submitAction={submitAction}
            loading={loading}
            submitButtonText="Reset Password"
            submitBtnSm
        >
            <h5 className="mb-4">Reset Password</h5>

            <div className="row">
                <div className="col-md-6">
                    <Controller
                        name="password"
                        control={control}
                        render={({ field: { ref } }) => (
                            <TextInput
                                id="password"
                                labelText="Password"
                                type="password"
                                isInvalid={!!errors.password}
                                required
                                errorMessage={
                                    (errors.password && errors.password.message) ||
                                    "Invalid Password"
                                }
                                ref={ref}
                                {...register("password", {
                                    required: true,
                                    pattern: RegexPattern.password,
                                })}
                            />
                        )}
                    />
                </div>
                <div className="col-md-6">
                    <Controller
                        name="confirmPassword"
                        control={control}
                        render={({ field: { ref } }) => (
                            <TextInput
                                id="confirmPassword"
                                labelText="Confirm Password"
                                type="password"
                                isInvalid={!!errors.confirmPassword}
                                required
                                errorMessage={
                                    (errors.confirmPassword && errors.confirmPassword.message) ||
                                    "Invalid Password"
                                }
                                ref={ref}
                                {...register("confirmPassword", {
                                    required: true,
                                    validate: (value) =>
                                        value === password || "Passwords do not match",
                                })}
                            />
                        )}
                    />
                </div>
            </div>
        </FormContainer>
    );
};

export default ResetPassword;
